import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PrimaryDrawer } from "../theme/Drawer";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HomeIcon from "@mui/icons-material/Home";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BedIcon from "@mui/icons-material/Bed";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import TimelineIcon from "@mui/icons-material/Timeline";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSelector, useDispatch } from "react-redux";
import { menuAction } from "../redux/reducers/Menu";
import BadgeIcon from "@mui/icons-material/Badge";
import { modalDeleteAction } from "../redux/reducers/Modal";
import DangerModal from "../components/DangerModal";

const drawerWidth = 260;

const DrawerMenu = () => {
  const navigateTo = useNavigate(),
    dispatch = useDispatch(),
    menuState = useSelector((state) => state.Menu.minimized);

  useEffect(() => {
    setOpenDrawer(menuState);
  }, [menuState]);

  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [bookingClicked, setBookingClicked] = React.useState(false);
  const [productsClicked, setProductsClicked] = React.useState(false);
  const [cashClicked, setCashClicked] = React.useState(false);
  const [settingClicked, setSettingClicked] = React.useState(false);
  const [reportClicked, setReportClicked] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState("signOut");
  const [signOutView, setSignOutView] = useState(false);

  const deleteModalStatus = useSelector(
    (state) => state.Modal.deleteModalState
  );

  useEffect(() => {
    setShowDeleteModal(deleteModalStatus);
  }, [deleteModalStatus]);

  const optionClicked = (option) => {
    navigateTo(`/${option}`);
    setOpenDrawer(false);
    dispatch(menuAction());
  };

  const signOutSession = () => {
    setSignOutView(true);
    dispatch(modalDeleteAction()).then((response) => {
      localStorage.removeItem("htuser");
      localStorage.removeItem("ht-fullname");
      localStorage.removeItem("ht-role");
    });
    //dispatch(modalDeleteAction())
  };

  const subMenu = (option) => {
    // clean
    setBookingClicked(false);
    setProductsClicked(false);
    setCashClicked(false);
    setSettingClicked(false);
    setReportClicked(false);

    switch (option) {
      case "booking":
        setBookingClicked(!bookingClicked);
        break;
      case "product":
        setProductsClicked(!productsClicked);
        break;
      case "cash":
        setCashClicked(!cashClicked);
        break;
      case "setting":
        setSettingClicked(!settingClicked);
        break;
      case "report":
        setReportClicked(!reportClicked);
        break;
      default:
        return null;
    }
  };

  return (
    <>
      {showDeleteModal && deleteModal !== "" && signOutView && (
        <DangerModal view={deleteModal} />
      )}
      <PrimaryDrawer
        variant="temporary"
        anchor="left"
        open={openDrawer}
        onClose={() => dispatch(menuAction())}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
          },
        }}
      >
        <List sx={{ color: "#FFF", mt: 1 }}>
          <ListItem
            onClick={() => optionClicked("dashboard")}
            sx={{ px: 1, py: 0, mb: 0.5 }}
          >
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "0", width: "20%" }}>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Dashboard</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>

          <ListItem
            onClick={() => optionClicked("clients")}
            sx={{ px: 1, py: 0, mb: 0.5 }}
          >
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "0", width: "20%" }}>
                <PeopleAltIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Clientes</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>

          <ListItem
            onClick={() => optionClicked("users")}
            sx={{ px: 1, py: 0, mb: 0.5 }}
          >
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "0", width: "20%" }}>
                <BadgeIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Usuarios</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>

          <ListItem
            onClick={() => subMenu("booking")}
            sx={{ px: 1, py: 0, mb: 0.5 }}
          >
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "0", width: "20%" }}>
                <BedIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Reservar</Typography>
              </ListItemText>
              <ListItemIcon sx={{ width: "5%", minWidth: "0" }}>
                {bookingClicked ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          {bookingClicked && (
            <div>
              <ListItem
                sx={{ p: 0, pl: 8 }}
                onClick={() => optionClicked("bookings")}
              >
                <ListItemButton>
                  <ListItemText>
                    <Typography>• Individual</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </div>
          )}

          <ListItem
            onClick={() => subMenu("setting")}
            sx={{ px: 1, py: 0, mb: 0.5 }}
          >
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "0", width: "20%" }}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Configuración</Typography>
              </ListItemText>
              <ListItemIcon sx={{ width: "5%", minWidth: "0" }}>
                {settingClicked ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          {settingClicked && (
            <div>
              <ListItem
                sx={{ p: 0, pl: 8 }}
                onClick={() => optionClicked("levels")}
              >
                <ListItemButton>
                  <ListItemText>
                    <Typography>• Niveles</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>

              <ListItem
                sx={{ p: 0, pl: 8 }}
                onClick={() => optionClicked("rooms")}
              >
                <ListItemButton>
                  <ListItemText>
                    <Typography>• Habitaciones</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>

              <ListItem
                sx={{ p: 0, pl: 8 }}
                onClick={() => optionClicked("categories")}
              >
                <ListItemButton>
                  <ListItemText>
                    <Typography>• Categorías</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </div>
          )}

          <ListItem
            onClick={() => subMenu("report")}
            sx={{ px: 1, py: 0, mb: 0.5 }}
          >
            <ListItemButton>
              <ListItemIcon sx={{ minWidth: "0", width: "20%" }}>
                <TimelineIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Reportes</Typography>
              </ListItemText>
              <ListItemIcon sx={{ width: "5%", minWidth: "0" }}>
                {reportClicked ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          {reportClicked && (
            <div>
              <ListItem
                sx={{ p: 0, pl: 8 }}
                onClick={() => optionClicked("monthlyreport")}
              >
                <ListItemButton>
                  <ListItemText>
                    <Typography>• Mensual</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </div>
          )}
        </List>
        <List
          sx={{
            position: "absolute",
            bottom: "0",
            color: "#FFF",
            width: "100%",
          }}
        >
          <ListItem onClick={() => signOutSession()}>
            <ListItemButton>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>Cerrar Sesión</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>
      </PrimaryDrawer>
    </>
  );
};

export default DrawerMenu;
